import {useDispatch, useSelector, useStore} from 'react-redux';
import type {AppDispatch, AppStore, RootState} from '@src/store.ts';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
